
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pathname]",
      function () {
        return require("private-next-pages/[pathname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pathname]"])
      });
    }
  